enum WebViewEventIdEnum {
	REQUEST_NATIVE_CAMERA = 'request_native_camera',
	VERIFICATION_SUCCESS = 'verification_success',
	VERIFICATION_FAILURE = 'verification_failure'
}

export default WebViewEventIdEnum;
